import { render, staticRenderFns } from "./preRegisterDetail.vue?vue&type=template&id=21e039d0&scoped=true"
import script from "./preRegisterDetail.vue?vue&type=script&lang=js"
export * from "./preRegisterDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21e039d0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/www/wwwroot/node/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('21e039d0')) {
      api.createRecord('21e039d0', component.options)
    } else {
      api.reload('21e039d0', component.options)
    }
    module.hot.accept("./preRegisterDetail.vue?vue&type=template&id=21e039d0&scoped=true", function () {
      api.rerender('21e039d0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/shop/preRegisterDetail.vue"
export default component.exports